<template>
  <div id="content-wrapper">
    <form @submit.prevent>
      <div>
        <div class="row m-0 mb-3 justify-content-space-between">
          <div
            class="
              p-0
              col-xl-5 col-lg-6
              d-flex
              align-items-center
              justify-content-space-between
            "
          >
            <div class="font-weight-bold">Tên ứng dụng</div>
            <v-select
              class="flex-1-0 ml-2"
              :options="listAppPermissions"
              id="id"
              label="name"
              :reduce="(app) => app.id"
              v-model="requestForm.appId"
              :readonly="true"
              placeholder="Chọn ứng dụng"
              @input="timDanhSachGroup()"
              :disabled="isIframe"
            >
              <span slot="no-options"> Không tìm thấy dữ liệu </span></v-select
            >
          </div>
          <div>
            <base-button
              v-if="hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.THEM)"
              button="Thêm mới"
              @click="themMoi()"
              class="btn search-information-btn d-block float-right"
              >THÊM MỚI
            </base-button>
          </div>
        </div>
      </div>
    </form>
    <div class="box-form-result">
      <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
      <DataTable :value="danhSachGroupNoiBo" :loading="isLoadingTable">
        <Column
          field="id"
          dataKey="id"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
                slotProps.index +
                1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="code"
          header="Mã nhóm người dùng"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.GroupCode"
              @change="layDanhSachGroupPaging"
            />
          </template>
          <template #body="slotProps">
            <router-link
              class="color-unset"
              :to="
                `${ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.XEM}/${slotProps.data.id}/xem`
              "
            >
              <span>{{ slotProps.data.code }}</span>
            </router-link>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="name"
          header="Tên nhóm người dùng"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.GroupName"
              @change="layDanhSachGroupPaging"
            />
          </template>
          <template #body="slotProps">
            <router-link
              class="color-unset"
              :to="
                `${ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.XEM}/${slotProps.data.id}/xem`
              "
            >
              <span>{{ slotProps.data.name }}</span>
            </router-link>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="description"
          header="Mô tả"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.Description"
              @change="layDanhSachGroupPaging"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.description }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="appName"
          header="Tên ứng dụng"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.appName"
              @change="layDanhSachGroupPaging"
            />
          </template>
          <template #body="slotProps">
            <div v-html="slotProps.data.appName"></div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 150px"
          v-if="
            hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.SUA) ||
              hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA)
          "
        >
          <template #body="slotProps">
            <div class="text-center">
              <router-link
                class="color-unset"
                :to="
                  `${ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME}/${slotProps.data.id}`
                "
              >
                <font-awesome-icon
                  icon="edit"
                  v-if="hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.SUA)"
                  v-b-popover.hover.top="'Sửa nhóm người dùng'"
                  class="cursor-pointer color-red"
                />
              </router-link>
              <font-awesome-icon
                icon="trash-alt"
                v-if="hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA)"
                v-b-popover.hover.top="'Xóa nhóm người dùng'"
                class="cursor-pointer color-red ml-2"
                @click="moFormXoaVaiTro(slotProps.data)"
              />
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />
    <b-modal
      centered
      ref="tao-group-modal"
      size="xl"
      title="Tạo nhóm người dùng"
      no-close-on-backdrop
    >
      <FormGroup ref="tao-group" />
      <template v-slot:modal-footer>
        <div class="w-100 center">
          <base-button
            :button="BO_QUA_BUTTON_LABEL"
            @click="hideModal()"
            class="btn btn-line"
          >
            {{ BO_QUA_BUTTON_LABEL }}
          </base-button>
          <base-button
            button="Tạo"
            @click="taoVaiTro()"
            class="btn btn-main ml-2"
          >
            Lưu
          </base-button>
          <base-button button="Đóng" @click="hideModal()" class="btn btn-line">
            Đóng
          </base-button>
        </div>
      </template>
    </b-modal>
    <ModalConfirm :title="groupDaChon.name" @confirmed="xoaVaiTroThanhCong" />
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import FormGroup from "@/components/pages/quan-tri-he-thong/group/FormGroup";
import ModalConfirm from "@/components/modal/ModalConfirm";
import {
  BANG_GROUP,
  BO_QUA_BUTTON_LABEL,
  ROUTE_NAME,
  PERMISSION_NAME,
} from "@/constants/constants";
import { THEM_MOI_GROUP_THANH_CONG } from "@/constants/message";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import _cloneDeep from "lodash/cloneDeep";
import { hasPermissionUser } from "@/utils/permissionUtils";
import {
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";
const defaultRequestForm = {
  appId: null,
  filterBy: "",
  GroupCode: "",
  GroupName: "",
  DepartmentName: "",
  Description: "",
  ApplicationName: "",
};
export default {
  name: "DanhSachGroup",
  components: {
    BasePagination,
    FormGroup,
    ModalConfirm,
  },
  data() {
    return {
      PERMISSION_NAME,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        sortBy: "",
        sortType: "",
        pageSize: 10,
        pageIndex: 1,
      },
      requestForm: _cloneDeep(defaultRequestForm),
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      groupDaChon: {},
      emptyHeaderTable: [
        BANG_GROUP.code,
        BANG_GROUP.name,
        BANG_GROUP.donVi,
        BANG_GROUP.description,
        BANG_GROUP.appName,
        BANG_GROUP.thaoTac,
      ],
    };
  },
  computed: {
    ...mapGetters({
      danhSachGroupPaging: "group/danhSachGroupPaging",
      appId: "common/appId",
      danhSachApp: "app/tatCaApp",
      listApp: "app/listApp",
      isIframe: "common/isIframe",
      //   danhSachQuyenTheoNguoiDung: "permission/danhSachQuyenTheoNguoiDung",
      //   danhSachNguoiDung: "role/danhSachNguoiDungTheoVaiTro"
    }),
    listAppPermissions() {
      if(this.listApp && this.listApp.length > 0) {
        let convertDataListApp = this.listApp.map((item) => {
          return {
            ...item,
            code: item.appCode
          }
        })
        let arrayData = []
        this.danhSachApp.forEach((item) => convertDataListApp.forEach((item2) => {
          if(item.code === item2.code) {
            arrayData.push(item)
          }
        }))
        return arrayData
      }
      return []
    },
    danhSachGroupNoiBo() {
      return this.layDanhSachGroupNoiBo(this.danhSachGroupPaging);
    },
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.danhSachGroupPaging.items);
    },
  },
  watch: {
    danhSachGroupPaging: {
      handler() {
        this.totalPages = this.danhSachGroupPaging.totalPage;
        this.totalRows = _isNil(this.danhSachGroupPaging.totalCount)
          ? 0
          : this.danhSachGroupPaging.totalCount;
      },
      immediate: true,
    },
    "requestInformation.pageIndex": {
      handler() {
        this.layDanhSachGroupPaging();
      },
    },
    "requestForm.appId": {
      handler() {
        this.timDanhSachGroup();
        setValueToStorageByKey(
          LOCAL_STORAGE_KEY.APP_ID,
          this.requestForm.appId
        );
        this.$store.dispatch("common/setAppId", this.requestForm.appId);
      },
      deep: true,
    },
  },
  created() {
    //let appId = getValueFromStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
    // this.requestForm.appId = this.appId;
    this.layDanhSachGroupPaging();
    this.layDanhSachApp();
    this.$store.dispatch("app/getListApp");
  },
  methods: {
    hasPermissionUser,
    themMoi() {
      this.$router.push({
        path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME}/tao-moi`,
        params: {
          laTaoMoi: true,
        },
      });
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    moFormTaoGroup() {
      this.$refs["tao-group-modal"].show();
    },
    hideModal() {
      this.$refs["tao-group-modal"].hide();
    },
    async taoVaiTro() {
      const isValid = await this.$refs["tao-group"].$refs.observer.validate();
      const $vm = this;
      if (isValid) {
        this.$store
          .dispatch(
            "group/themMoiGroup",
            this.$refs["tao-group"].getInternalForm()
          )
          .then((response) => {
            if (response.data.succeeded) {
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: THEM_MOI_GROUP_THANH_CONG,
              });
              $vm.$refs["tao-group-modal"].hide();
              $vm.layDanhSachGroupPaging();
            }
          });
      }
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachGroupPaging();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
    },
    timDanhSachGroup() {
      this.requestInformation.pageIndex = 1;
      this.layDanhSachGroupPaging();
    },
    layDanhSachGroupPaging() {
      const payload = {
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store.dispatch("group/danhSachGroupPaging", payload).then(() => {
        this.isLoadingTable = false;
      });
    },
    layDanhSachGroupNoiBo(danhSachGroup) {
      if (_isEmpty(danhSachGroup.items)) {
        return [];
      }
      return danhSachGroup.items.map((item, index) => {
        return {
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          code: _isNil(item.code) ? "" : item.code,
          name: _isNil(item.name) ? "" : item.name,
          donVi: _isNil(item.donVi) ? "" : item.donVi,
          description: _isNil(item.description) ? "" : item.description,
          id: item.id,
          appName: _isNil(item.appName) ? "" : item.appName,
          thaoTac: "thaoTac",
        };
      });
    },
    moFormXoaVaiTro(item) {
      this.groupDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaVaiTroThanhCong(confirm) {
      if (confirm) {
        this.$bvModal.hide("modal-confirm");
        this.$store
          .dispatch("group/xoaGroup", { id: this.groupDaChon.id })
          .then(() => this.layDanhSachGroupPaging());
      }
    },
    getFieldName() {
      if (_isEmpty(this.danhSachGroupNoiBo)) {
        return [];
      }
      return Object.keys(this.danhSachGroupNoiBo[0])
        .filter((key) => key !== "id")
        .map((key) => {
          return {
            key: key,
            label: BANG_GROUP[key],
            tdClass: ["stt"].includes(key) ? "center" : "",
          };
        });
    },
  },
};
</script>
